// app/page.tsx


'use client'

import Sidebar from '@/components/Sidebar'
import Header from '@/components/Header'
import StatCard from '@/components/StatCard'
import VerifiedCard from '@/components/VerifiedCard'
import MonthlyRegistrationsChart from '@/components/MonthlyRegistrationsChart'
import VehicleAgeSection from '@/components/VehicleAgeSection'
import { Car, User, Briefcase } from 'lucide-react'
import { useAuth } from '@/context/AuthContext'
import { JSX } from 'react'

interface StatCardProps {
  title: string
  value: string
  icon: JSX.Element
  trend: string
  color: {
    bg: string
    text: string
  }
}

export default function Home() {
  const { user } = useAuth()

  const stats: StatCardProps[] = [
    {
      title: 'Nombre total de taxis enregistrés',
      value: '1,250',
      icon: <Car size={24} />,
      trend: '+5.2%',
      color: { bg: 'bg-blue-50', text: 'text-primary' },
    },
    {
      title: 'Nombre total de chauffeurs',
      value: '3,402',
      icon: <User size={24} />,
      trend: '+12%',
      color: { bg: 'bg-orange-50', text: 'text-orange-500' },
    },
    {
      title: 'Nombre total de propriétaires',
      value: '890',
      icon: <Briefcase size={24} />,
      trend: '+2.1%',
      color: { bg: 'bg-purple-50', text: 'text-purple-600' },
    },
  ]

  return (
    <div className="bg-background-light text-slate-800 font-display h-screen flex overflow-hidden">
      <Sidebar />

      <main className="flex-1 flex flex-col h-full relative overflow-hidden bg-background-light">
        <Header title={`Bienvenue, ${user?.name}`} />

        <div className="flex-1 overflow-y-auto p-4 sm:p-8">
          <div className="max-w-6xl mx-auto flex flex-col gap-6">
            {/* Header Section */}
            <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-2">
              <div>
                <p className="text-slate-500 text-sm font-medium">
  {new Date().toLocaleDateString('fr-CM', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })}
</p>

                <h2 className="text-2xl font-bold text-slate-800">
                  Bon retour, {user?.name}
                </h2>
              </div>

              <div className="hidden sm:flex bg-white rounded-lg border border-slate-200 p-1">
                <button className="px-3 py-1 text-xs font-semibold bg-slate-100 text-slate-700 rounded shadow-sm">
                  Aujourd’hui
                </button>
                <button className="px-3 py-1 text-xs font-medium text-slate-500 hover:text-slate-700">
                  Semaine
                </button>
                <button className="px-3 py-1 text-xs font-medium text-slate-500 hover:text-slate-700">
                  Mois
                </button>
              </div>
            </div>

            {/* Row 1: KPI Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
              {stats.map((stat) => (
                <StatCard key={stat.title} {...stat} />
              ))}
            </div>

            {/* Row 2: Verified % Cards (NEW) */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
              <VerifiedCard
                title="Taxis Vérifiés"
                subtitle="Vérifiés et conformes"
                value="60.9%"
                tone="green"
              />
              <VerifiedCard
                title="Chauffeurs Vérifiés"
                subtitle="Certifiés avec succès"
                value="68%"
                tone="orange"
              />
              <VerifiedCard
                title="Propriétaires Vérifiés"
                subtitle="Identifiés officiellement"
                value="55%"
                tone="purple"
              />
            </div>

            {/* Recensements par mois (NEW main chart) */}
            <MonthlyRegistrationsChart />

            {/* Âge du parc automobile (NEW section) */}
            <VehicleAgeSection />
          </div>
        </div>
      </main>
    </div>
  )
}
